import React, { ReactNode } from "react";
import ExternalLink from "../ExternalLink";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  network: string;
  href: string;
  children: ReactNode;
};

const popupConfig: Record<string, string | number> = {
  height: 400,
  width: 550,
  location: "no",
  toolbar: "no",
  status: "no",
  directories: "no",
  menubar: "no",
  scrollbars: "yes",
  resizable: "no",
  centerscreen: "yes",
  chrome: "yes",
};

const popupConfigString = Object.keys(popupConfig)
  .map((key) => `${key}=${popupConfig[key]}`)
  .join(", ");

const onClick = (
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  href: string
) => {
  event.preventDefault();
  window.open(href, "", popupConfigString);
};

const ShareLinkWithPopup = ({
  children,
  className,

  style,
  href,
}: Props) => (
  <ExternalLink
    href={href}
    onClick={(event) => onClick(event, href)}
    className={className}
    showExternalIcon={false}
    style={style}
    target="_blank"
    rel="nofollow noopener noreferrer"
  >
    {children}
  </ExternalLink>
);

export default ShareLinkWithPopup;
